import React from 'react';
import { FaFilm, FaUsers, FaGraduationCap, FaHeart } from 'react-icons/fa';

export default function Philanthropy() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12 bg-black text-gray-100">
      <h1 className="text-4xl md:text-5xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#FF1493] to-[#FF8C00]">
        AweitFlix Cares
      </h1>
      
      <div className="space-y-8 text-lg">
        <section className="bg-gray-900 p-6 rounded-xl border border-gray-800">
          <h2 className="text-3xl font-bold mb-6 text-white">Empowering African Storytellers</h2>
          <p className="leading-relaxed mb-6">
            At AweitFlix, we're committed to nurturing African talent and amplifying authentic African stories. Through our AweitFlix Foundation, we provide grants, training, and platforms for emerging filmmakers across the continent to bring their visions to life.
          </p>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-3">
                <FaFilm className="text-2xl mr-3 text-[#FF1493]" />
                <h3 className="text-xl font-bold text-white">Film Grants Program</h3>
              </div>
              <p>
                We award production grants to 20 promising filmmakers annually, providing funding, equipment, and mentorship to create original African content.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-3">
                <FaUsers className="text-2xl mr-3 text-[#FF8C00]" />
                <h3 className="text-xl font-bold text-white">Community Screenings</h3>
              </div>
              <p>
                Our mobile cinema initiative brings films to underserved communities, hosting free screenings and discussions in rural areas across East Africa.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-gray-900 p-6 rounded-xl border border-gray-800">
          <h2 className="text-3xl font-bold mb-6 text-white">Education Initiatives</h2>
          
          <div className="flex items-start mb-6">
            <FaGraduationCap className="text-3xl mr-4 mt-1 text-[#FF1493]" />
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Film School Scholarships</h3>
              <p>
                We partner with leading African film schools to provide full scholarships for talented students who demonstrate exceptional promise in storytelling.
              </p>
            </div>
          </div>

          <div className="flex items-start">
            <FaHeart className="text-3xl mr-4 mt-1 text-[#FF8C00]" />
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Youth Media Labs</h3>
              <p>
                Our after-school programs in Kampala, Nairobi, and Lagos teach digital storytelling skills to high school students, equipping the next generation of African creators.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-gradient-to-r from-[#FF1493] to-[#FF8C00] text-white p-8 rounded-xl">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4">"Feel the Reel, Share the Dream"</h2>
            <p className="text-xl mb-6">
              Every subscription helps fund our philanthropic initiatives. Join us in shaping the future of African cinema.
            </p>
            <div className="space-y-2">
              <p className="font-medium">Email: impact@aweitflix.com</p>
              <p className="font-medium">Phone: +256 761832669</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}